<script>
  export let style
</script>

<style>
  .kb-footer {
    display: flex;
    align-items: center;
  }
</style>

<div class="$style.kb-footer" {style}>
  <slot />
</div>
